import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '@/locales/en.json'

// i18n scaffold. UI strings are English; content (book/vocab/questions) is often Arabic and is
// rendered with dir="auto" at the component level (see design/Auto.tsx) so RTL works regardless
// of UI language. Additional locales can be added later without touching call sites.
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
